import React, { Fragment, useState } from "react";
import TextField from "@mui/material/TextField";

import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { InputAdornment, IconButton } from "@mui/material";
// import { Controller } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


import { Button } from "@mui/material";
import { set } from "date-fns";
import { de } from "date-fns/locale";
//import { useHistory } from "react-router-dom";


export default function ManualLogin() {
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  //handle submit
  function handleSubmit() {
    //Get data from form
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    //send data to server
    //console.log("email: " + email + " password: " + password);
    //post data to server
    fetch("/user/validateuser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email, password: password }),
    })
      .then((response) => response.json())
      .then((data) => {

        console.log(data);
        //if login is successful, redirect to dasboard page

        if (data !== null && data !== undefined) {
          //go to dashboard

          localStorage.setItem("userToken", 'Bearer ' + data.token);
          localStorage.setItem("userEmail", data.userEmail);
          window.location.href = "/dashboard";

        }
        else {
          //show error message
          alert("Invalid email or password");
        }
      });

  };
  return (

    //Login form
    <Fragment>
      <h2>Log In</h2>
      <form>
        <Grid container spacing={1}>
          <Grid item xs={4} sm={4}>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              autoComplete="username"
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
          </Grid>
          <Grid item xs={4} sm={4}>
            <TextField
              id="password"
              label="Password"
              variant="outlined"
              autoComplete="current-password"
              type={showPassword ? "text" : "password"}
              fullWidth
              required
              InputProps={{ // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="body2" color="text.secondary" >
              <a href="/sendPassword">Forgot Password?</a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="body2" style={{ textAlign: 'left', paddingTop: '10px', color: 'red' }} >
              {message}
            </Typography>
          </Grid>
        </Grid>
        {/* <br />
        <br /> */}
      </form>
      <Button color="primary" variant="outlined" onClick={handleSubmit}>Log In</Button>
      <Grid container spacing={2} style={{ paddingTop: '20px' }}>
        <Grid item xs={4} sm={4}>

          <Typography variant="body2" color="text.secondary" >
            <div>
              Subscribers were informed on May 19, 2025, of a change in the authentication method.  If you have not changed your password then you need to do that before you log in:
            </div>
          </Typography>
          <div>



            <ol>
              <Typography variant="body2" color="text.secondary"style={{ paddingTop: '20px' }} >
                <li>

                  Please select “Forgot Password” above to begin the reset process.
                </li>
              </Typography>
              <Typography variant="body2" color="text.secondary" >
                <li>

                  When you select “Forgot Password”, enter your ProcessPro email which will send a secure link to set your new password.
                </li>
              </Typography>
              <Typography variant="body2" color="text.secondary" >
                <li>

                  Follow the link, enter and confirm your new password, and ensure it meets the password standards outlined on the page.
                </li>
              </Typography>
              <Typography variant="body2" color="text.secondary" >
                <li>

                  You will get a confirmation on the reset password page.
                </li>
              </Typography>
            </ol>
            <Typography variant="body2" color="text.secondary" >
              Once reset, click the Login link in the top right hand corner and log in to the system.
            </Typography>
          
            <Typography variant="body2" color="text.secondary" style={{ paddingTop: '20px' }} >
              If you have any questions or encounter any issues during this process, please don’t hesitate to contact us at contact@theprocesspros.ca
            </Typography>
          </div>
        </Grid>


      </Grid>

    </Fragment>
  );
}
